import React from 'react';
import NodalUi from '../../NodalUi';

// TODO: rehydrate Marker
export default class MapOLMarker extends NodalUi {

    constructor() {
        super();
    }
}